import { useCategories } from "@/hooks/queries";
import { ChipGroup } from "@components/ChipGroup";
import { RelationshipLevelSelect } from "@components/RelationshipLevelSelect";
import { FormParams } from "@pages/Profile";
import { getCategoryItem, getSortedCategories } from "@utils/index";
import styles from "./styles.module.css";

export const ProfileInfo = ({ profile, profileId }: { profile: FormParams; profileId?: string }) => {
  const { data: categories, map, isCategoryMap } = useCategories();

  const getCategoryNames = (arr: string[]) =>
    arr.map((id) => getCategoryItem(id, categories, map)?.name);

  const {
    name,
    roles_ids = [],
    reps_ids = [],
    markets_ids = [],
    locations_ids = [],
    vendor,
  } = profile;

  const sortedRoles = getSortedCategories(roles_ids, map, isCategoryMap);
  const sortedReps = getSortedCategories(reps_ids, map, isCategoryMap);
  const sortedMarkets = getSortedCategories(markets_ids, map, isCategoryMap);
  const sortedLocations = getSortedCategories(
    locations_ids,
    map,
    isCategoryMap
  );

  const marketOptions = sortedMarkets.map((id) => ({
    value: id,
    title: getCategoryItem(id, categories, map)?.name ?? "",
  }));

  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoWrapper}>
        <p className={styles.infoLabel}>Name</p>
        <p className={`${styles.infoValue} ${styles.pt1}`}>{name}</p>
      </div>
      {profileId && (
        <div className={styles.infoWrapper}>
          <p className={styles.infoLabel}>Relationship Level</p>
          <div className={styles.infoValue}>
            <RelationshipLevelSelect
              profileId={profileId}
              currentLevel={profile.relationship_level}
            />
          </div>
        </div>
      )}
      <div className={styles.infoWrapper}>
        <p className={styles.infoLabel}>Role</p>
        <p className={styles.infoValue}>
          {getCategoryNames(sortedRoles).join(", ")}
        </p>
      </div>
      <div className={styles.infoWrapper}>
        <p className={styles.infoLabel}>Market</p>
        <div className={styles.marketsWrapper}>
          <ChipGroup options={marketOptions} />
        </div>
      </div>
      <div className={styles.infoWrapper}>
        <p className={styles.infoLabel}>Country</p>
        <p className={`${styles.infoValue} ${styles.pt1}`}>
          {getCategoryNames(sortedLocations).join(", ")}
        </p>
      </div>
      <div className={styles.infoWrapper}>
        <p className={styles.infoLabel}>Lighting Vendor</p>
        <p className={`${styles.infoValue} ${styles.pt1}`}>{vendor}</p>
      </div>
      <div className={styles.infoWrapper}>
        <p className={styles.infoLabel}>Rep</p>
        <p className={`${styles.infoValue} ${styles.pt1}`}>
          {getCategoryNames(sortedReps).join(", ")}
        </p>
      </div>
    </div>
  );
};
